import gql from "graphql-tag";

export const hybridQueries = {
  sideNav: gql`
    query SideNav($appMode: AppMode!) {
      me {
        isSuperUser
        userId
        roleName
        createAgent
        ddEnabled
        ttEnabled
        ddCompanyPl
        ttD1CompanyPl
        ttD2CompanyPl
        ttD3CompanyPl
        ttD4CompanyPl
        paymentPayableSum
        creditSummary {
          creditGiven
          creditGivenToDownlines
          creditBalance
        }
      }
      releases(appMode: $appMode) {
        id
        releaseDate
        windowCloseAt
        windowIsOpen
      }
    }
  `,
};
